function unwrapSingle(r) { return r.data.item; }
function unwrapList(r) { return r.data.items; }


module.service('UserService', function($http, ApiUrl) {
    var url = ApiUrl.partial('person');

    function departmentUrl(id) {
        return url(id, 'departments');
    }

    function programUrl(id) {
        return url(id, 'programs');
    }

    this.get = function(id) {;
        return $http.get(url(id)).then(unwrapSingle);
    };

    this.getPermissions = function(id, programId) {
        return $http.get(url(id, 'permissions'), {params: {
            program_id: programId,
        }}).then(function(r) {
            return r.data.permissions;
        })
    }

    this.createUser = function(data) {
        return $http.post(url(), data).then(unwrapSingle);
    }

    this.resetPassword = function(email) {
        return $http.post('/api/session/reset', {email: email});
    }

    this.youthbuildDepartments = function() {
        return $http.get(ApiUrl('department')).then(unwrapList);
    };

    this.getDepartmentStaff = function(id) {
        return $http.get(departmentUrl(id)).then(unwrapList);
    };

    this.addDepartmentStaff = function(id, department, consultant) {
        return $http.post(departmentUrl(id), {
            department_id: department,
            is_consultant: !!consultant,
        }).then(unwrapSingle);
    };

    this.updateDepartmentStaff = function(id, department, consultant) {
        return $http.patch(departmentUrl(id), {
            department_id: department,
            is_consultant: !!consultant,
        }).then(unwrapSingle);
    };

    this.deleteDepartmentStaff = function(id, department) {
        return $http({
            method: 'DELETE',
            url: departmentUrl(id),
            data: {department_id: department},
            headers: {'Content-Type': 'application/json'},
        });
    };


    this.getProgramStaff = function(id, coach) {
        return $http.get(programUrl(id), {params: {coach: !!coach}})
            .then(unwrapList);
    };

    this.updateProgramStaff = function(id, data) {
        return $http.patch(programUrl(id), data).then(unwrapSingle);
    };

    this.addProgramStaff = function(id, data) {
        return $http.post(programUrl(id), data).then(unwrapSingle);
    };

    this.deleteProgramStaff = function(id, program_id) {
        return $http.delete(programUrl(id), {
            data: {program_id: program_id},
            headers: {'Content-Type': 'application/json'},
        });
    };


    // Program User Page

    function programUserUrl(program_id, user_id) {
        var url = ApiUrl.partial('program', program_id, 'users');
        return user_id ? url(user_id) : url();
    }

    this.getProgramUsers = function(program_id) {
        return $http.get(programUserUrl(program_id)).then(unwrapList);
    };

    this.updateProgramUser = function(program_id, user_id, data) {
        return $http.patch(programUserUrl(program_id, user_id), data)
            .then(unwrapSingle);
    };

    this.removeProgramUser = function(program_id, user_id) {
        return $http.delete(programUserUrl(program_id, user_id));
    };

    this.emailSearch = function(program_id, email) {
        return $http.get(programUserUrl(program_id) + '/search',
            {params:{email: email}}).then(unwrapSingle);
    };

    this.newProgramUser = function(program_id, data) {
        return $http.post(programUserUrl(program_id), data)
            .then(unwrapSingle);
    };
});